'use client'

import React from 'react'
import { useTranslations } from 'next-intl'
import { cn } from '@/utilities/cn'

interface SaleBadgeProps {
  className?: string
}

export const SaleBadge: React.FC<SaleBadgeProps> = ({ className }) => {
  const t = useTranslations('product')

  return (
    <span
      data-testid="sale-badge"
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-bold font-mono uppercase tracking-wider bg-red-600 text-white shadow-sm shrink-0',
        className,
      )}
    >
      {t('sale')}
    </span>
  )
}
